import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import SubNav from "../../../../shared/subnav/SubNav";
import Grid from "@material-ui/core/Grid";
import VehicleInfo from "../../../../shared/vehicleInfo/VehicleInfo";
import { vehicleInfo } from "./VehicleInfoMockData";
import BackToButton from "../../../../shared/backToButton/BackToButton";
import NscVehicles from "../nscVehicles/NscVehicles";
import NscOptions from "../nscOptions/NscOptions";
import { logMsg } from "../../../../common/Logger";
import {
  CASH,
  CASH_OPTIONS,
  CHARGE,
  DEFAULT_VEHICLE,
  DEFAULT_YEAR,
  DISCOUNT,
  FEES_MAP,
  NONE,
  PRICE_CHANGE_INFO,
  PRICING,
} from "../../../../common/Constants";
import DealerFees from "../dealerFees/DealerFees";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
import PricingClient from "../../../../shared/clients/PricingClient";
import UpperCaseText from "../../../../utils/UpperCaseText";
import { withTranslation } from "react-i18next";
import VehicleCatalogClient from "../../../../shared/clients/VehicleCatalogClient";
import {
  displayError,
  isUnknownError,
  PAGE_ERROR,
} from "../../../../errors/ErrorConstants";
import ModelDropDown from "./ModelDropDown";
import YearDropDown from "./YearDropDown";
import ExportAll from "./ExportAll";
import LowerCaseText from "../../../../utils/LowerCaseText";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import { MarketGroups } from "../../../../shared/marketGroups/MarketGroups";

class NscCurrentPricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
      renderApp: false,
      modelData: null,
      hasError: [],
      buttonEnabled: false,
      selectedModel:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.model
          ? this.props.location.query.model
          : DEFAULT_VEHICLE,
      selectedYear:
        this.props.location &&
        this.props.location.query &&
        this.props.location.query.model
          ? this.props.location.query.modelYear
          : DEFAULT_YEAR,
      catalogIds: [],
      yearDropDownValues: [],
      optionsData: [],
      pricingData: [],
      feesData: [],
      released: [],
      priceUpdatesAvailable: [],
      errorMessage: undefined,
      currencySymbol:
        this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
          ? this.props.localizedInfo.defaultCurrency.symbol
          : this.props.t("CurrentPricing.na"),
    };
    this.newVehicleLine = false;
    this.vehicleTitle = this.vehicleTitle.bind(this);
    this.viewOnlyPricing = false;
    this.adminView =
      this.props.userDetails.roles.includes("EMP_TEAMADMIN") ||
      this.props.userDetails.roles.includes("EMP_PO");
  }

  componentDidMount() {
    this.fetchVehicleLines();
  }

  onModelChange = (event) => {
    if (event) {
      event.preventDefault();
    }

    const maxYear = this.getYears(this.state.modelData, event.target.value);

    const catalogIds =
      this.state.modelData &&
      this.state.modelData
        .filter(
          (x) =>
            x.model === event.target.value &&
            x.year.toString() === maxYear.toString()
        )
        .map((model) => model.catalogId && model.catalogId.toString());
    this.setState(
      {
        selectedModel: event.target.value,
        renderApp: false,
        catalogIds: catalogIds,
        selectedTab: 0,
      },
      () => {
        this.fetchNscPricing();
      }
    );
  };

  onYearChange = (event) => {
    const catalogIds = this.getCatalogIds(
      this.state.modelData,
      this.state.selectedModel,
      event.target.value
    );
    this.setState(
      {
        selectedYear: event.target.value,
        renderApp: false,
        optionsData: [],
        feesData: [],
        pricingData: [],
        released: [],
        catalogIds,
        selectedTab: 0,
      },
      () => {
        this.fetchNscPricing();
      }
    );
  };
  onMarketChange = (event) => {
    event.preventDefault();
    const market = event.target.value;
    this.setState(
      {
        renderApp: false,
        currencySymbol: this.getCurrencySymbol(),
      },
      () => {
        this.props.updateCurrentMarket(market);
        this.fetchVehicleLines();
      }
    );
  };
  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  getCurrencySymbol() {
    if (this.props.localizedInfo && this.props.localizedInfo.defaultCurrency) {
      return this.props.localizedInfo.defaultCurrency.symbol;
    }
    return "";
  }

  fromPendingAction = () => {
    if (
      this.props.location &&
      (this.props.location.actionName === PRICING ||
        this.props.location.actionName === PRICE_CHANGE_INFO)
    ) {
      return true;
    }
  };

  getCatalogIds = (vehicleLines, selectedModel, selectedYear) => {
    const catalogIds = [];
    if (selectedYear !== null && selectedModel !== null)
      vehicleLines.forEach((vehicleLine) => {
        if (
          vehicleLine.model === selectedModel &&
          (selectedYear === "All" ||
            vehicleLine.year.toString() === selectedYear.toString())
        ) {
          catalogIds.push(vehicleLine.catalogId);
        }
      });
    return catalogIds;
  };

  fetchNscPricing() {
    this.props.hideOrShow(true);
    const pricingData = [];
    const optionsData = [];
    const feesData = [];
    let released;
    let priceUpdatesAvailable;
    PricingClient.getNscPricing(
      this.props.user,
      this.state.catalogIds,
      this.props.selectedMarket
    )
      .then((res) => {
        if (res && res.length > 0 && res[0].result) {
          res.forEach((data) => {
            data.result.products.forEach((entity) => {
              entity.vehiclePricingDetails.forEach((item) => {
                item["catalogId"] = entity.catalogId;
                item["vehicleLine"] = entity.vehicleLine;
                item["marketedSeries"] = entity.marketedSeries;
                item["marketedSeriesId"] = entity.marketedSeriesId;
                item["year"] = entity.year;
                item["ptvl"] = entity.ptvl;
                item["adjType"] = this.getAdjType(item.adj);
                pricingData.push(item);
              });
            });
            optionsData.push(...data.result.options);
            feesData.push(...data.result.fees);
            released = data.result.released;
            priceUpdatesAvailable = data.result.priceUpdatesAvailable;
          });
        } else if (
          res &&
          res.length > 0 &&
          res[0].error &&
          res[0].error.messages &&
          res[0].error.messages.length > 0
        ) {
          this.setState({
            errorMessage: res[0].error.messages[0],
          });
        }
        this.setState({
          pricingData,
          optionsData,
          feesData,
          released,
          priceUpdatesAvailable,
        });
        this.checkReleased();
      })
      .catch((reason) => {
        logMsg("reason", reason);
      })
      .finally(() => {
        this.setState({ renderApp: true });
        this.props.hideOrShow(false);
      });
  }

  getDefaultModel = (vehicleLines) => {
    const models = vehicleLines.map((vehicleLine) => vehicleLine.model);
    return models.includes(this.state.selectedModel)
      ? this.state.selectedModel
      : models[0];
  };

  getAdjType = (adj) => {
    let valueDropDown = NONE;
    if (Math.sign(adj) === 1) {
      valueDropDown = CHARGE;
    } else if (Math.sign(adj) === -1) {
      valueDropDown = DISCOUNT;
    }
    return valueDropDown;
  };

  fetchVehicleLines() {
    this.props.hideOrShow(true);
    VehicleCatalogClient.getNscVehicleLines(
      this.props.user,
      false,
      this.props.selectedMarket
    )
      .then((res) => {
        const selectedModel = this.getDefaultModel(res);
        const selectedYear = this.getYears(
          res,
          selectedModel,
          this.fromPendingAction()
        );
        const catalogIds = res
          .filter(
            (x) =>
              x.model === this.state.selectedModel &&
              x.year.toString() === selectedYear.toString()
          )
          .map((model) => model.catalogId.toString());
        this.setState({
          modelData: res,
          catalogIds,
        });
      })
      .catch((error) => {
        logMsg("reason", error);
        if (isUnknownError(error)) {
          this.setState({ hasError: [PAGE_ERROR] });
        }
      })
      .finally(() => {
        this.fetchNscPricing();
        this.props.hideOrShow(false);
      });
  }

  checkReleased = () => {
    let buttonEnabled = false;
    if (
      this.props.userDetails.roles.includes("EMP_TEAMADMIN") ||
      this.props.userDetails.roles.includes("EMP_PO")
    ) {
      this.setState({ buttonEnabled });
    } else if (!this.state.released) {
      this.setState({ buttonEnabled: true });
    } else {
      this.state.feesData &&
        this.state.feesData.forEach((fees) => {
          if (!fees.released) {
            buttonEnabled = true;
          }
        });
      this.state.pricingData &&
        this.state.pricingData.forEach((pricingRow) => {
          if (!pricingRow.released) {
            this.newVehicleLine = true;
            buttonEnabled = true;
          }
        });
      this.setState({ buttonEnabled });
    }
  };

  getYears = (data, selectedModel, fromPA) => {
    const years =
      data &&
      data
        .filter((x) => x.model === selectedModel)
        .map((model) => model.year.toString());

    const maxYear = Math.max.apply(Math, years);
    const selectedYear = fromPA
      ? this.props.location.query && this.props.location.query.modelYear
      : years && maxYear;
    this.setState({
      yearDropDownValues: years,
      selectedYear: selectedYear,
    });

    return selectedYear;
  };

  constructTabs() {
    return [
      {
        menuName: this.props.t("CurrentPricing.dealerFees"),
        enabled: true,
        id: "dealerFees",
      },
      {
        menuName: this.props.t("CurrentPricing.vehicles"),
        enabled: true,
        id: "vehicles",
      },
      {
        menuName: this.props.t("CurrentPricing.options"),
        enabled: true,
        id: "options",
      },
    ];
  }

  saveResponseBody = () => {
    const pricingData = [];
    const feesData = [];
    if (!this.state.released) {
      this.state.pricingData.forEach((item) => {
        pricingData.push(item);
      });
      return {
        pricing: pricingData,
        options: this.state.optionsData,
        fees: this.state.feesData,
        catalogIds: this.state.catalogIds,
      };
    } else {
      this.state.pricingData.forEach((item) => {
        if (!item.released) {
          pricingData.push(item);
        }
      });
      this.state.feesData.forEach((fees) => {
        if (!fees.released) {
          feesData.push(fees);
        }
      });
      return {
        pricing: pricingData,
        options: this.state.optionsData,
        fees: feesData,
        catalogIds: this.state.catalogIds,
      };
    }
  };

  saveNscPricing = () => {
    const requestData = this.saveResponseBody();
    if (
      (requestData.pricing && requestData.pricing.length > 0) ||
      (requestData.fees && requestData.fees.length > 0) ||
      (requestData.options && requestData.options.length > 0) ||
      this.state.priceUpdatesAvailable
    ) {
      this.props.hideOrShow(true);
      this.setState({ renderApp: false });
      PricingClient.saveNscPricingCall(
        this.props.user,
        requestData,
        this.props.selectedMarket
      )
        .then(() => {
          this.removePricingPendingAction();
        })
        .catch((err) => {
          logMsg("error", err);
        })
        .finally(() => {
          this.fetchNscPricing();
          this.props.hideOrShow(false);
        });
    }
  };

  removePricingPendingAction = () => {
    const vehicleLines =
      this.state.modelData &&
      this.state.modelData
        .filter(
          (vehicleInfo) =>
            (this.state.selectedYear !== "All" &&
              vehicleInfo.model === this.state.selectedModel &&
              Number(vehicleInfo.year) === Number(this.state.selectedYear)) ||
            (this.state.selectedYear === "All" &&
              vehicleInfo.model === this.state.selectedModel)
        )
        .map((vehicleInfo) => vehicleInfo.vehicleLine);

    PendingActionClient.removeNscPendingAction(
      this.props.user,
      PRICING,
      vehicleLines,
      this.props.selectedMarket
    );
  };

  getSubHeader = () => {
    return (
      <div className={`${styles.left} pagePaddingLeft pagePaddingBottom`}>
        <HasPermissionTo
          perform={["subHeaderText:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          condition={
            LowerCaseText(this.props.paymentType) === CASH ||
            CASH_OPTIONS.ONLINE_APPROVED_MARKETS.includes(
              UpperCaseText(this.props.selectedMarket)
            )
          }
          render={() => {
            return this.state.selectedTab === 0 ? (
              <div className={styles.dealerTrans}>
                <p>{this.props.t("DealerFees.subHeader")} </p>
              </div>
            ) : this.state.selectedTab === 1 ? (
              <>
                <div className={styles.dealerTrans}>
                  {this.props.t("DealerVehicles.subheader1")}
                </div>
                <div className={styles.equation}>
                  {this.props.t("DealerVehicles.rrp")}{" "}
                  <span className={styles.minus}> &#8722; </span>{" "}
                  {this.props.t("DealerVehicles.variableMarketingOffer")}
                  <span className={styles.plus}> &#43;/&#8722; </span>{" "}
                  {this.props.t("DealerVehicles.dealerAdjustment")}
                  <span className={styles.equal}> &#61; </span>{" "}
                  {this.props.t("DealerVehicles.vehicle1")}
                </div>
                <div className={styles.equation}>
                  {this.props.t("DealerVehicles.vehicle2")}
                  <span className={styles.plus}> &#43; </span>
                  {this.props.t("DealerVehicles.dealerFees")}{" "}
                  <span className={styles.equal}> &#61; </span>{" "}
                  {this.props.t("DealerVehicles.transactionPrice")}
                </div>
              </>
            ) : (
              <div className={styles.dealerTrans}>
                <p>{this.props.t("DealerVehicles.setAccessoriesPricing")}</p>
              </div>
            );
          }}
        />

        <div className={styles.modelDiv}>
          <div className={styles.dropdownContainer}>
            <Grid item md={3} xs={4}>
              <div className={styles.subTitle}>
                {this.props.t("NamePlate.model")}
              </div>
              <ModelDropDown
                {...this.props}
                modelData={this.state.modelData}
                selectedModel={this.state.selectedModel}
                modelDropDownValues={this.state.modelDropDownValues}
                updateModel={this.onModelChange}
              />
            </Grid>

            <Grid item md={3} xs={4}>
              <div className={styles.subTitle}>
                {this.props.t("NamePlate.modelYear")}
              </div>
              <YearDropDown
                {...this.props}
                yearValues={this.state.yearDropDownValues}
                updateYear={this.onYearChange}
                selectedYear={this.state.selectedYear}
                showAll={false}
              />
            </Grid>
            <Grid item md={5} xs={3} />
            <Grid item md={1} xs={1} className={styles.exportAllDiv}>
              <ExportAll
                {...this.props}
                feesData={this.state.feesData}
                pricingData={this.state.pricingData}
                optionsData={this.state.optionsData}
                selectedModel={this.state.selectedModel}
                selectedYear={this.state.selectedYear}
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  };

  vehicleTitle() {
    return (
      <Grid className={styles.infoBar} container>
        <Grid item xs={6}>
          <VehicleInfo
            vehicleTitle={vehicleInfo.vehicleTitle}
            year={vehicleInfo.year}
          />
        </Grid>
      </Grid>
    );
  }
  getSubNav = () => {
    return (
      <div className={styles.left}>
        <HasPermissionTo
          perform={["orderSearchMarketDropDown:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          render={() => (
            <SubNav
              {...this.props}
              title={this.props.t("DealerVehicles.currentPricing")}
              subTitle={this.vehicleTitle}
              renderSubHeader={true}
              subHeader={this.getSubHeader}
              selectedTab={this.state.selectedTab}
              action={this.handleTabChange}
              tabs={this.constructTabs()}
              dashboard={false}
              showCustomDropdown={false}
              showCustomMarketDropdown={true}
              listOfMarkets={MarketGroups(this.props.user.market)}
              updateMarket={this.onMarketChange}
              showAll={false}
            />
          )}
          noRender={() => (
            <SubNav
              {...this.props}
              title={this.props.t("DealerVehicles.currentPricing")}
              subTitle={this.vehicleTitle}
              renderSubHeader={true}
              subHeader={this.getSubHeader}
              selectedTab={this.state.selectedTab}
              action={this.handleTabChange}
              tabs={this.constructTabs()}
            />
          )}
        />
      </div>
    );
  };

  render() {
    if (displayError(this.state.hasError))
      throw new Error(this.state.hasError[0]);
    return (
      this.state.renderApp && (
        <div className="pageWrapper">
          <BackToButton
            backToUrl="/pricing"
            display={this.props.t("PricingWrapper.backToPricing")}
          />
          {this.getSubNav()}
          {this.state.selectedTab === 0 ? (
            <DealerFees
              {...this.props}
              viewOnlyPricing={this.viewOnlyPricing}
              handleTabChange={this.handleTabChange}
              released={!this.state.buttonEnabled}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              currencySymbol={this.state.currencySymbol}
              feesData={this.state.feesData}
              catalogIds={this.state.catalogIds}
              errorMessage={this.state.errorMessage}
            />
          ) : this.state.selectedTab === 1 ? (
            <NscVehicles
              {...this.props}
              viewOnlyPricing={this.viewOnlyPricing}
              handleTabChange={this.handleTabChange}
              released={!this.state.buttonEnabled}
              feesData={this.state.feesData}
              pricingData={this.state.pricingData}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              currencySymbol={this.state.currencySymbol}
              fees={FEES_MAP[UpperCaseText(this.props.selectedMarket)]}
              catalogIds={this.state.catalogIds}
              errorMessage={this.state.errorMessage}
              adminView={this.adminView}
            />
          ) : (
            <NscOptions
              {...this.props}
              viewOnlyPricing={this.viewOnlyPricing}
              isDisabled={true}
              savePricing={this.saveNscPricing}
              released={!this.state.buttonEnabled}
              options={this.state.optionsData}
              priceUpdatesAvailable={this.state.priceUpdatesAvailable}
              currencySymbol={this.state.currencySymbol}
              catalogIds={this.state.catalogIds}
              errorMessage={this.state.errorMessage}
            />
          )}
        </div>
      )
    );
  }
}

export default withTranslation("emp")(NscCurrentPricing);
